import { isUnit, Unit } from '@prismamedia/one-brandkey';

export type RoleUnit = Unit | 'ALL';

export function isRoleUnit(maybeRoleUnit: unknown): maybeRoleUnit is RoleUnit {
  return isUnit(maybeRoleUnit) || maybeRoleUnit === 'ALL';
}
